import React from "react";
import "./Pagination.css";

const Pagination = ({
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
}) => {
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalCount);

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter(
      (p) =>
        p === 1 ||
        p === totalPages ||
        (p >= currentPage - 2 && p <= currentPage + 2),
    )
    .reduce((acc, p, idx, arr) => {
      if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
      acc.push(p);
      return acc;
    }, []);

  return (
    <div className="pagination-container">
      {/* Left */}
      {/* <span className="pagination-info">
        Showing <strong>{start}</strong> – <strong>{end}</strong> of{" "}
        <strong>{totalCount}</strong> tenders
      </span> */}

      {/* Right */}
      <div className="pagination-controls">
        {/* Prev */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`pagination-btn nav-btn ${currentPage === 1 ? "disabled" : ""
            }`}
        >
          ← Prev
        </button>

        {/* Numbers */}
        {pages.map((item, idx) =>
          item === "..." ? (
            <span key={idx} className="pagination-ellipsis">
              …
            </span>
          ) : (
            <button
              key={item}
              onClick={() => onPageChange(item)}
              className={`pagination-btn ${item === currentPage ? "active" : ""
                }`}
            >
              {item}
            </button>
          ),
        )}

        {/* Next */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`pagination-btn nav-btn ${currentPage === totalPages ? "disabled" : ""
            }`}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default Pagination;
